module.exports = __webpack_public_path__ + "static/media/desktop.7b8c5584.png";